export default {
  PDR1: 1,
  PDR2: 2,
  PDR3: 3,
  Suncorp: 4,
  RACQ: 5
}
